import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Routes } from 'react-router-dom'
import { Box, Paper } from '@mui/material'
import PageHeader from 'components/AppBar/PageHeader'
import { BasePathProvider } from 'components/Providers'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import Protected from 'components/Protected'
import NotFound from 'components/NotFound'
import { hasPermission } from 'store'
import { search as searchAddressChanges } from 'store/needs-attention/address-change'
import { search as searchMissingContact } from 'store/needs-attention/missing-contact'
import Tabs, { basePath, tabConfig } from './Tabs'
import AddressChange from './AddressChange'
import MissingContact from './MissingContact'

export default function NeedsAttention() {
  const dispatch = useDispatch()

  useEffect(() => {
    if (hasPermission('miscellaneous.needs-attention')) {
      dispatch(searchAddressChanges())
      dispatch(searchMissingContact())
    }
  }, [dispatch])

  return (
    <BasePathProvider value={`${basePath}/`}>
      <Box sx={{ mb: 2 }}>
        <PageHeader title={'Needs Attention'} />
      </Box>
      <Paper sx={{ width: '100%', p: 2 }}>
        <Tabs />
        <Routes>
          <Route path="/">
            <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
            <Route
              path="address-change/*"
              element={
                <Protected permission="miscellaneous.needs-attention">
                  <AddressChange />
                </Protected>
              }
            />
            <Route
              path="missing-contact"
              element={
                <Protected permission="miscellaneous.needs-attention">
                  <MissingContact />
                </Protected>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Paper>
    </BasePathProvider>
  )
}
